module.exports = __webpack_public_path__ + "img/notHandled.14fdae32.svg";